module.exports = __webpack_public_path__ + "img/icon-2.15700745.png";